var MathUtils = /** @class */ (function () {
    function MathUtils() {
    }
    MathUtils.round = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    };
    MathUtils.floor = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.floor(value * multiplier) / multiplier;
    };
    MathUtils.ceil = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.ceil(value * multiplier) / multiplier;
    };
    MathUtils.roundToNearest5 = function (value, precision) {
        var precisionUnit = 5 / Math.pow(10, precision || 0);
        if (precisionUnit === 0) {
            return value;
        }
        var unitRawCount = 0;
        unitRawCount = value / precisionUnit;
        var roundedCount = Math.round(unitRawCount);
        return this.round(roundedCount * precisionUnit, precision);
    };
    return MathUtils;
}());
export { MathUtils };
//# sourceMappingURL=math-utils.js.map